export const COL_WIDTHS = {
  component: 220,
  version: 140,
  lastVersion: 140,
  upgradeStatus: 160,
  lastUpgradedAt: 520,
} as const;

export const stylingObject = {
  container: { p: 2 },
  title: { fontWeight: 600 },
  search: { maxWidth: 420 },
  emptyState: { py: 4, textAlign: 'center' as const },
  tableContainer: { border: '1px solid #e0e0e0', borderRadius: 2 },
  table: { tableLayout: 'fixed' as const },
  tableHead: { background: '#F4F9FA' },
  th: { color: '#11567F', fontWeight: 600 },
  thCell: { py: 1.5 },
  tdCell: { py: 1.25 },
  monospaceEllipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontFamily: 'monospace',
  },
  valueText: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
} as const;

